<template>
  <v-app class="app">
    <AppHeader
      :isLoggedIn="isLoggedIn"
      @logout="logout"
    />

    <v-main
      class="px-5 mt-2 mb-4"
      style="min-height: 80vh"
    >
      <div v-if="isLoadingPage">
        <v-progress-linear indeterminate></v-progress-linear>
      </div>
      <router-view
        v-else
        style="height: 100%"
      />
    </v-main>

    <footer class="px-5">{{ $t('main.title') }} - {{ new Date().getFullYear() }}</footer>
  </v-app>
</template>

<script>
import AppHeader from '@/components/header/index.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { serviceFactory } from '@/keycloack/factory'
import { userStoreForKeycloack } from '@/store/userStoreForKeycloack'
import { disciplineGeneratedApi } from './api'

export default {
  name: 'App',

  components: {
    AppHeader
  },

  data: () => ({
    form: {
      username: null,
      password: null
    },
    isLoadingPage: false,
    openFormForLogin: false,
    keycloakService: null,
    isChecking: false
  }),

  async created() {
    this.keycloakService = serviceFactory(userStoreForKeycloack)
  },

  mounted() {
    this.$store.dispatch('breakpoint/addWindowWidthEventListener')
  },

  unmounted() {
    this.$store.dispatch('breakpoint/removeWindowWidthEventListener')
  },

  computed: {
    ...mapGetters('user', ['isLoggedIn', 'errorMsg', 'adminRole'])
  },

  methods: {
    ...mapActions('dictionaries', ['getAllDirectory', 'getDirectory']),
    ...mapMutations('user', ['setCurrentUser', 'addRole', 'setErrorMsg', 'setAccessToken']),

    logout() {
      this.keycloakService.logout()
    },
    async checkDiscipline() {
      if (this.isChecking) return
      this.isChecking = true
      try {
        document.querySelectorAll('.toast').forEach(el => el.remove())
        await disciplineGeneratedApi.checkDiscipline()
        localStorage.removeItem('disciplineCheckError')
      } catch (e) {
        const errorMsg = e?.data?.message || this.$t('errorMessages.error')
        localStorage.setItem('disciplineCheckError', JSON.stringify({
          message: errorMsg,
          timestamp: Date.now()
        }))
        this.$toastr('warning', {
          msg: e?.data?.message || this.$t('errorMessages.error'),
          position: 'toast-top-right',
          timeout: 0,
          closeOnHover: true,
          clickClose: true
        })
      } finally {
        this.isChecking = false
      }
    }
  },

  watch: {
    async isLoggedIn(val) {
      if (val) {
        this.isLoadingPage = true
        try {
          await this.getAllDirectory()
          await this.getDirectory('pivotField')
        } catch (e) {
          console.error(e)
        } finally {
          this.isLoadingPage = false
        }
      }
    },
    $route: {
      immediate: true,
      handler() {
        if (this.adminRole) {
          this.checkDiscipline()
        }
      }
    }
  }
}
</script>

<style lang="scss">
.app {
  background-color: #f4f5fa;
}

.required::after {
  content: '*';
  margin-right: 4px;
  color: #e60000;
}
</style>
